// Created by hejikun on 2017/11/2 0002.
let authAdapter = [
    {
      path: '/auth_adapter',
      name: '滇医通',
      component: () => import('@/pages/auth-adapter/index.vue')
    }
  ]

  export default authAdapter
